module.exports = __webpack_public_path__ + "img/badge-vue-js.cec90966.png";